// Wire scalars the kernel does not define [02 §6.1 "Scalars"]. Ids, business dates, currencies,
// UoM, money, unit rates and FX rates come from kernel/ and units/ — nothing here redefines them.
import { z } from 'zod';

import { qtyDecimalSchema, uomSchema } from '../units/index.ts';

/** Exact decimal carried as a string; never a JS float [02 §6.1]. */
export const decimalStringSchema = z
  .string()
  .regex(/^-?(0|[1-9]\d*)(\.\d+)?$/, { message: 'invalid decimal string' });

/** Instant as ISO-8601 UTC ending in `Z` [02 §6.1]. */
export const utcTimestampSchema = z.iso.datetime();

/**
 * Quantity on the wire: `{ qty: "12.500", uom: "M" }` [02 §6.1; MB D8]. The in-memory form is the
 * kernel `Qty` (`{ milli, uom }`); API and event payloads carry the decimal string.
 */
export const qtyDtoSchema = z.strictObject({ qty: qtyDecimalSchema, uom: uomSchema });

/** Percentage on the wire as a decimal string with up to 4 dp, e.g. "6.0000" [04 §11.3; 02 §6.1]. */
export const percentSchema = z
  .string()
  .regex(/^-?(0|[1-9]\d{0,6})(\.\d{1,4})?$/, { message: 'invalid percentage' });

export type DecimalString = z.output<typeof decimalStringSchema>;
export type QtyDto = z.output<typeof qtyDtoSchema>;
